import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import setupAxiosInterceptors from "../utils/axiosInterceptor";

const InterceptorSetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setupAxiosInterceptors({ navigate, dispatch });
  }, [navigate, dispatch]);

  return null;
};

export default InterceptorSetup;
